import React from 'react';

import { useDataType } from '../../../common/hooks/use-data-type';
import { DATA_TYPE } from '../../../common/config/data-type';
import { composeGetTranslation } from '../../../../../../../../common/react/utils/translations';
import { ToggleInput } from '../../../../../../../../common/react/components/ToggleInput';
import { UPDATE_DATA_TYPE } from '../../../../../../store/js/modules/statspro/career-and-season-stats/actions';
import { useSelector } from 'react-redux';
import { careerAndSeasonStatsBenchmarkingSelector } from '../../../../../../store/js/modules/statspro/career-and-season-stats/selectors/benchmarking-selector';
import { careerAndSeasonStatsDataTypeSelector } from '../../../../../../store/js/modules/statspro/career-and-season-stats/selectors/data-type-selector';

export const DataTypeToggle = () => {
    const benchmarking = useSelector( careerAndSeasonStatsBenchmarkingSelector );
    const initialDataType = useSelector( careerAndSeasonStatsDataTypeSelector );

    const { dataType, updateDataType } = useDataType( {
        initialDataType,
        onUpdateActionCreator: UPDATE_DATA_TYPE.request,
        isBenchmarkingActive: benchmarking.isActive
    } );

    const getTranslation = composeGetTranslation( 'label.statsLeaders.dataType.' );

    return (
        <ToggleInput
            id="careers-and-season-stats-data-type-toggle"
            value={ dataType.type.toLowerCase().includes( DATA_TYPE.TOTALS ) ? DATA_TYPE.TOTALS : DATA_TYPE.AVERAGES }
            onChange={ updateDataType }
            options={ [
                {
                    label: getTranslation( DATA_TYPE.TOTALS ),
                    value: DATA_TYPE.TOTALS
                },
                {
                    label: getTranslation( DATA_TYPE.AVERAGES ),
                    value: DATA_TYPE.AVERAGES,
                }
            ] }
        />
    );
};
